<template>
  <div class="status-field flex items-center h-100">
    <div
      class="status cursor-pointer"
      :class="params.data.status ? 'active' : 'inactive'"
      @click="ChangeStatus"
    ></div>
    <div class="field">{{ params.data.full_name }}</div>
  </div>
</template>

<script>
export default {
  methods: {
    ChangeStatus () {
      const payload = {
        id: this.params.data.product_uuid,
        data: { status: !this.params.data.status ? 'active' : 'inactive' }
      }

      this.$vs.loading()
      this.$store.dispatch('user/Edit', payload)
      .then(res => {
        if (res.success) {
          this.params.data.refreshData()
          this.ShowSuccessMessage({ title: 'Success', text: 'User status has been changed' })
        }
      })
      .catch(err => this.ShowErrorMessage({ title: 'Error', text: err }))
      .finally(() => this.$vs.loading.close())
    },

    // Notify
    ShowSuccessMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-check',
        color: 'success',
        title,
        text
      })
    },
    ShowErrorMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger',
        title,
        text
      })
    }
  },
}
</script>
